import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatPaginator, MatTableDataSource, PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-web-storage';
import * as moment from 'moment';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NovoInscritoFormComponent } from 'src/app/components/novo-inscrito-form/novo-inscrito-form.component';
import { Acoes } from 'src/app/model/enum/acoes.enum';
import { DataTransferService } from 'src/app/service/data-transfer.service';
import { DocumentoService } from 'src/app/service/documento.service';
import { ExcelService } from 'src/app/service/excel/excel.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { EditalDTO } from '../../model/dto/edital.dto';
import { RequerimentoDTO } from '../../model/dto/requerimento.dto';
import { EditalService } from '../../service/edital/edital.service';
import { RequerimentoService } from '../../service/requerimento.service';
import { RelacaoInscritosComponent } from '../relacao-inscritos/relacao-inscritos.component';



@Component({
  selector: 'app-listar-inscritos',
  templateUrl: './listar-inscritos.component.html',
  styleUrls: ['./listar-inscritos.component.css'],
})
export class ListarInscritosComponent implements OnInit {

  formListar: FormGroup;
  editais: EditalDTO[];
  requerimento: RequerimentoDTO[] = [];
  relacaoHTML: RelacaoInscritosComponent;
  numeracao: number[] = [];
  displayedColumns: string[] = ['select', 'position', 'nome', 'cpfCnpj', 'numPrecatorio', 'dataRecebimento', "acoes"];
  dataSource = new MatTableDataSource<RequerimentoDTO>();
  selection = new SelectionModel<RequerimentoDTO>(true, []);
  pageEvent: PageEvent;
  desativar: any = false;
  @BlockUI() blocker: NgBlockUI;
  pageSizes = [30, 50, 100];
  pageSize: number = 30;
  @ViewChild("paginatorRequerimento") paginatorRequerimento: MatPaginator;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageIndex: number = 0;
  totalDataLength: number = 0;
  filtros: any = {};

  maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());



  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }


  constructor(private editalService: EditalService,
    private fb: FormBuilder,
    private requerimentoService: RequerimentoService,
    private router: Router,
    private dataTransfer: DataTransferService,
    private excelService: ExcelService,
    private documentoService: DocumentoService,
    private dialog: MatDialog,
    private EditalService: EditalService,
    public local: LocalStorageService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.montarForm();
    this.pesquisarEdital().subscribe({
      next: (response) => {
        this.editais = response.data;
        this.local.set('home', 'listar-inscritos');
        this.aplicarFiltros();
      },
      error: (error) => {
        console.error('Erro ao buscar os dados:', error);
      }
    });
  }

  aplicarFiltros() {
    const filtroSalvo = sessionStorage.getItem('filtroPesquisa');
    if (filtroSalvo) {
      const filtro = JSON.parse(filtroSalvo);
  
      // Preencher o formulário com os dados salvos
      this.formListar.setValue({
        cpfCnpj: filtro.cpfCnpj,
        nrPrecatorio: filtro.nrPrecatorio,
        credor: filtro.credor,
        dtRecebimentoInicial: filtro.dtRecebimentoInicial ? moment(filtro.dtRecebimentoInicial, 'YYYY-MM-DD').toDate() : null,
        dtRecebimentoFinal: filtro.dtRecebimentoFinal ? moment(filtro.dtRecebimentoFinal, 'YYYY-MM-DD').toDate() : null,
        edital: filtro.idEdital ? this.editais.find(edital => edital.id === filtro.idEdital) : ""
      });
  
      // Atribuir a paginação
      this.pageIndex = filtro.page;
      this.pageSize = filtro.size;
      this.totalDataLength = filtro.totalDataLength;

      this.cdr.detectChanges();
      this.buscarLista();
    }
  }

  montarForm() {
    this.formListar = this.fb.group({
      edital: new FormControl(''),
      credor: new FormControl(''),
      cpfCnpj: new FormControl(''),
      nrPrecatorio: new FormControl(''),
      dtRecebimentoInicial: new FormControl(''),
      dtRecebimentoFinal: new FormControl(''),
    });

    this.setupDateValidators('dtRecebimentoInicial', 'dtRecebimentoFinal');
    this.setupDateValidators('dtRecebimentoFinal', 'dtRecebimentoInicial');
  
    this.dataSource = new MatTableDataSource<RequerimentoDTO>();
  }

  private setupDateValidators(controlName: string, dependentControlName: string) {
    const control = this.formListar.get(controlName);
    const dependentControl = this.formListar.get(dependentControlName);
    control.valueChanges.pipe(
      debounceTime(300), 
      distinctUntilChanged() 
    ).subscribe((value) => {
      if (value) {
        dependentControl.setValidators([Validators.required]);
        Object.keys(this.formListar.controls).forEach(control => {
          this.formListar.get(control).markAsTouched();
        });
      } else {
        dependentControl.clearValidators();
      }
      dependentControl.updateValueAndValidity();
      this.validateDateRange();
    });
  }

  private validateDateRange() {
    const dtRecebimentoInicial = this.formListar.get('dtRecebimentoInicial') ? this.formListar.get('dtRecebimentoInicial').value : null;
    const dtRecebimentoFinal = this.formListar.get('dtRecebimentoFinal') ? this.formListar.get('dtRecebimentoFinal').value : null;
  
    if (dtRecebimentoInicial && dtRecebimentoFinal) {
      const isValid = new Date(dtRecebimentoInicial) < new Date(dtRecebimentoFinal);
      if (!isValid) {
        this.formListar.setErrors({ dateRangeInvalid: true });
        this.formListar.get('dtRecebimentoFinal').setErrors({ dateRangeInvalid: true });
      } else {
        this.formListar.setErrors(null);
      }
    } else {
      this.formListar.setErrors(null);
    }
  }

  pesquisarEdital() {
    return this.editalService.buscarEdital(2);
  }

  limparCampos() {
    this.montarForm();
    if (this.paginator) this.paginator.pageIndex = 0;
    this.totalDataLength = 0;
    sessionStorage.removeItem('filtroPesquisa'); 
  }


  buscarLista() {
    this.numeracao = [];
    this.desativar = this.isEditalBloqueado();
  
    if (this.isFormValido()) {
      const request = this.montarFiltro();
      this.executarBusca(request, this.atualizarLista.bind(this));
    }
  }

  gerarRelatorio() {
    if (this.isFormValido()) {
      const request = this.montarFiltroComTamanhoTotal();
      this.executarBusca(request, this.gerarArquivoExcel.bind(this));
    }
  }

  montarFiltro() {
    const formValues = this.formListar.value;
    const filtro = {
      cpfCnpj: this.removerCaracteresEspeciais(formValues.cpfCnpj),
      nrPrecatorio: this.removerCaracteresEspeciais(formValues.nrPrecatorio),
      credor: formValues.credor,
      dtRecebimentoInicial: this.formatarData(formValues.dtRecebimentoInicial),
      dtRecebimentoFinal: this.formatarData(formValues.dtRecebimentoFinal),
      idEdital: formValues.edital ? formValues.edital.id : "",
      page: this.pageIndex,
      size: this.pageSize,
      totalDataLength: this.totalDataLength
    };

    sessionStorage.setItem('filtroPesquisa', JSON.stringify(filtro));
    return filtro;
  }

  montarFiltroComTamanhoTotal() {
    const filtro = this.montarFiltro();
    filtro.page = 0;
    filtro.size = this.totalDataLength;
    return filtro;
  }

  executarBusca(request, callback) {
    this.blocker.start('Carregando...');
    this.limparListaSelecionada();
    this.requerimentoService.buscarLista(request).subscribe({
      next: callback,
      error: (error) => {
        console.error('Erro ao buscar os dados', error);
        this.blocker.stop();
      }
    });
  }

  limparListaSelecionada(){
    this.selection.clear();
    this.requerimento = [];
  }

  atualizarLista(data) {
    this.dataSource.data = data.content;
    this.totalDataLength = data.totalElements;
    this.numeracao = data.content.map((_, index) => index + this.pageIndex * this.pageSize);
    this.blocker.stop();
  }

  gerarArquivoExcel(data) {
    const relInscritos = data.content.map((req: RequerimentoDTO) => ({
      'Número Precatório': req.numPrecatorio,
      'Ano Orçamento': req.anoOrcamento,
      'Tipo Crédito': req.tipoCredito,
      'Data Cadastro Precatóroio': this.formatarDataPtBr(req.dataCadastro),
      'Data Cadastro Edital': this.formatarDataPtBr(req.dataCriacaoRequerimento),
      'Credor': req.credor.nome,
      'CPF/CNPJ': req.credor.cpfCnpj,
      'Edital': req.edital.nomeEdital,
      'Número Formulário': req.numFormulario,
    }));
    this.excelService.exportAsExcelFile(relInscritos, 'RelInscritos');
    this.blocker.stop();
  }

  isFormValido() {
    if (this.formListar.valid) {
      return true;
    } else {
      console.log("Formulário inválido. Verifique os campos.");
      return false;
    }
  }
  
  isEditalBloqueado() {
    const edital = this.formListar.get('edital').value;
    return edital.bloqueado === 1;
  }
  
  removerCaracteresEspeciais(valor: string) {
    return valor ? valor.replace(/[^0-9a-zA-Z]+/g, '') : "";
  }
  
  formatarData(data) {
    return data ? moment.utc(data).format('YYYY-MM-DD') : "";
  }
  
  formatarDataPtBr(data) {
    return moment(data).locale('pt-br').format('L');
  }

  visualizar(requerimento: RequerimentoDTO) {
    this.navegarComDados(requerimento, Acoes.VISUALIZAR);
  }

  compactar(requerimento: RequerimentoDTO) {
      this.navegarComDados(requerimento, Acoes.ZIP);
  }

  compactarTodos() {
      if (this.requerimento.length > 0) {
          this.navegarComDados(this.requerimento, Acoes.ZIP);
      } else {
          this.exibirInfo("compactar");
      }
  }

  imprimir() {
      if (this.requerimento.length > 0) {
        this.navegarComDados(this.requerimento, Acoes.IMPRIMIR);
      } else {
          this.exibirInfo("imprimir");
      }
  }

  private navegarComDados(requerimento: RequerimentoDTO | RequerimentoDTO[], acao: Acoes) {
      this.dataTransfer.setData({ requerimento: Array.isArray(requerimento) ? requerimento : [requerimento], acao });
      this.router.navigate(['impressao-inscritos']);
  }

  exibirInfo(acao: string) {
      Swal.fire({
          text: `Selecione ao menos um precatório para ${acao}.`,
          icon: 'warning',
      });
  }

  selecionado(event, requerimento: RequerimentoDTO): void {
    this.updateSelection(requerimento, event.checked); 
  }

  selecionadoTodos(): void {
    if (this.selection.hasValue()) {
      this.limparListaSelecionada();
    } else {
      this.dataSource.data.forEach(row => {
        this.updateSelection(row, true); 
      });
      this.selection.select(...this.dataSource.data);
    }
    this.cdr.detectChanges(); 
  }

  isRequerimentoSelecionado(requerimento: RequerimentoDTO): boolean {
    return this.requerimento.some(req => req.id === requerimento.id);
  }

  toggleSelection(requerimento: RequerimentoDTO): void {
    const add = !this.isRequerimentoSelecionado(requerimento);
    this.updateSelection(requerimento, add); 
  }

  private updateSelection(requerimento: RequerimentoDTO, add: boolean): void {
    if (add) {
      if (!this.isRequerimentoSelecionado(requerimento)) {
        this.requerimento.push(requerimento);
        this.selection.select(requerimento);
      }
    } else {
      this.requerimento = this.requerimento.filter(req => req.id !== requerimento.id);
      this.selection.deselect(requerimento);
    }
    this.cdr.detectChanges(); 
  }

  btPesquisar() {
    this.pageIndex = 0;
    if (this.paginator) this.paginator.pageIndex = 0;
    this.buscarLista();
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.buscarLista();
  }

  clickGrid(event) {
    this.requerimento = this.selection.selected;
  }

  editar(requerimento: RequerimentoDTO) {
    console.log(this.desativar)
    if (!this.desativar) {
      this.dataTransfer.setData([1, 2])
      this.router.navigate(["formulario", requerimento.id])
    }
  }

  bloquear() {
    Swal.fire({
      title: 'Deseja bloquear esse edital?',
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const bloqueado = await this.editalService.bloquear(this.formListar.get('edital').value.id, 1)
        this.desativar = bloqueado;
        Swal.fire('Boqueado!', '', 'success')
      } else if (result.isDenied) {
        Swal.fire('Ocorreu um erro !', '', 'info')
      }
    })

  }

  novoCredor() {
    this.dialog.open(NovoInscritoFormComponent, {
      width: '40%',
      data: {
        data: this.dataSource.data[0].edital,
      }
    }
    )
  }

  public cpfcnpjmask = function (rawValue) {
    var numbers = rawValue.match(/\d/g);
    var numberLength = 0;
    if (numbers) {
        numberLength = numbers.join('').length;
    }
    if (numberLength <= 11) {
        return [
            /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/,];
    } else {
        return [
            /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '/', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-',
            /[0-9]/, /[0-9]/,];
    }
  };
  public precatoriomask = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
}
